 <div class="content-header">
                <h2>Reporte de incidencias</h2>
            </div>

            <div class="incidencias-form-container">
                <form [formGroup]="formulario">
                    <div class="form-group">
                        <label for="descripcion-incidencia">Describa su incidencia:</label>
                        <textarea #txtAincidencia class="form-control" id="descripcion-incidencia" rows="10" placeholder="" formControlName="descripcionIncidencia"></textarea>
                        
                        <br>
                        <label for="subir-archivo">Adjuntar archivo:</label>
                    
                        <div class="document-upload-section">
                            <p class="formats-info">Formatos válidos de archivo: {{sFormatos}}</p>

                            <div class="aviso-frame">
                                <p>
                                    Al ingresar el archivo, verificar que el nombre del archivo no cuente con signos de puntuación,
                                    admiración
                                    o caracteres especiales como apóstrofes, guiones, etc.
                                </p>
                                <p>
                                    Nota: El tamaño límite de los archivos debe ser 40 MB por documento, mismos que en su conjunto no deberán de exceder de 360 MB por envío.
                                </p>
                            </div>
                            <div class="row mt-3 justify-content-end">
                                <div class="col-12 col-sm-auto">
                                    <button class="btn btn-file" (click)="openWindowFirma()">Seleccionar
                                        archivos </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-auto">
                            <div class="center">
                                <oaj-loader-itx [loading]="isLoadingFile" [sMensaje]="sMensajeLoad" #loaderSpinner></oaj-loader-itx>
                            </div>
                            @if(!isLoadingFile && showFiles){
                               <!--  <script>console.log('ya entro')</script>    -->                           
                            <oaj-lista-archivos-itx class="form-control" [archivos]="lstDocumentos" [verBorrar]="true"
                                (BorraDoc)="EliminarDocumentosPantalla($event)" [verPrevisualizar]="true" [OcultaSystemName]="true">
                            </oaj-lista-archivos-itx>
                            }
                        </div>
                    </div>

                    <div class="form-actions-right">
                        <button type="submit" class="btn-search" [disabled]="loading" (click)="insertaIncidencia()">
                            @if(!loading){
                            <span>Enviar</span>
                            }
                            @else{
                            <span class="d-flex align-items-center justify-content-center">
                                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Enviando...
                            </span>
                        }
                        </button>
                        

                    </div>
                    
                </form>
                <!-- <button class="btn btn-envio" (click)="insertaIncidencia()">Prueba Enviar Incidencia </button> --> 
                    <div>
                        <oaj-alert-itx></oaj-alert-itx>
                    </div>
            </div>